import { VideoLibraryDataTableActionTypes } from "../Constants/ActionTypes";

const initialState = {
  isTableLoading: false,
  isTableDisabled: false,
  activeBreakDownList: null,
  tableData: null,
  filteredTableData: null,
  selectedVideo: null,
  isTableEditable: false,
  errors: {
    tableFetchError: null,
  },
  tableSeasonInfo: null,
  loading: false,
  selectedColumnSet: {},
  selectedPlaylist: "",
};

export const VideoLibraryDataTableReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case VideoLibraryDataTableActionTypes.SET_IS_TABLE_DISABLED:
      return {
        ...state,
        isTableDisabled: payload,
      };

    case VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_TABLE_DATA:
      return {
        ...state,
        tableData: payload,
      };

    case VideoLibraryDataTableActionTypes.SET_SELECTED_COLUMN_SET: {
      return {
        ...state,
        selectedColumnSet: payload,
      };
    }

    case VideoLibraryDataTableActionTypes.TABLE_LOADING:
      return {
        ...state,
        isTableLoading: payload,
      };

    case VideoLibraryDataTableActionTypes.SET_ACTIVE_BREAKDOWN_LIST:
      return {
        ...state,
        activeBreakDownList: payload,
      };

    case VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_DATA_TABLE_BY_NAME:
      const { changes } = payload;
      const table = state?.filteredTableData
        ? "filteredTableData"
        : "tableData";
      return {
        ...state,
        [table]: state?.[table]?.map((breakdown) => {
          if (breakdown?.id === payload?.breakDownId) {
            return {
              ...breakdown,
              row: breakdown?.row?.map((el) => {
                if (el?.id === payload?.rowId) {
                  if (changes) {
                    return {
                      ...el,
                      ...changes,
                    };
                  } else {
                    return {
                      ...el,
                      [payload.fieldName]: payload.value,
                    };
                  }
                }
                return el;
              }),
            };
          }
          return breakdown;
        }),
      };

    case VideoLibraryDataTableActionTypes.FILTER_TABLE:
      return {
        ...state,
        filteredTableData: payload,
      };

    case VideoLibraryDataTableActionTypes.SELECTED_VIDEO_PATH:
      return {
        ...state,
        selectedVideo: payload,
      };

    case VideoLibraryDataTableActionTypes.SET_ERRORS:
      return {
        ...state,
        errors: {
          ...state.errors,
          [payload.errorField]: payload.errorMessage,
        },
      };

    case VideoLibraryDataTableActionTypes.UPDATE_VIDEO_NAME:
      return {
        ...state,
        tableData: state?.tableData?.map((breakdown) => {
          if (breakdown?.eventMedia?.id === payload?.videoId) {
            return {
              ...breakdown,
              eventMedia: {
                ...breakdown.eventMedia,
                eventMediaCategory: payload?.videoName,
              },
            };
          }
          return breakdown;
        }),
      };

    case VideoLibraryDataTableActionTypes.UPDATE_BREAKDOWN_POSSIBLE_VALUE:
      const { possibleValue: values, breakdownId } = payload;
      if (!Array.isArray(values) || !breakdownId) {
        return state; // Return the existing state if payload is invalid
      }
      return {
        ...state,
        //1: Update original breakdown list : Not needed
        // activeBreakDownList: state?.activeBreakDownList?.map((breakdown) => {
        //   if (breakdownId.toString() === breakdown?.id) {
        //     return {
        //       ...breakdown,
        //       possibleValues: Array.from(
        //         new Set([...values]) // Avoid duplicates
        //       ),
        //     };
        //   }
        //   return breakdown;
        // }),
        //2.Update breakdown list which is added into the table for each row
        tableData: state?.tableData?.map((ele) => {
          const updatedRow = ele?.row?.map((breakdown) => {
            if (breakdownId.toString() === breakdown?.id) {
              return {
                ...breakdown,
                possibleValues: Array.from(
                  new Set([...values]) // Avoid duplicates
                ),
              };
            }
            return breakdown;
          });
          return { ...ele, row: updatedRow };
        }),
      };

    case VideoLibraryDataTableActionTypes.DELETE_BREAKDOWN:
      return {
        ...state,
        tableData: state?.tableData?.map((breakdown) => {
          return {
            ...breakdown,
            row: breakdown?.row?.filter(
              (column) => column.id !== payload?.breakDownId
            ),
          };
        }),
        activeBreakDownList: state?.activeBreakDownList?.filter(
          (breakdown) => breakdown?.id !== payload?.breakDownId
        ),
      };

    case VideoLibraryDataTableActionTypes.UPDATE_BREAKDOWN:
      const { breakDownId, breakDownName, breakDownType, possibleValue } =
        payload;
      return {
        ...state,
        tableData: state?.tableData?.map((breakdown) => {
          const updatedRow = breakdown?.row?.map((row) => {
            if (row?.id === breakDownId) {
              return {
                ...row,
                breakdownName: breakDownName,
                possibleValues: possibleValue,
                type: breakDownType === 1 ? "Text" : "Number",
              };
            }
            return row;
          });
          return { ...breakdown, row: updatedRow };
        }),
      };

    case VideoLibraryDataTableActionTypes.SET_SELECTED_PLAYLIST:
      return {
        ...state,
        selectedPlaylist: payload,
      };

    case VideoLibraryDataTableActionTypes.IS_TABLE_EDITABLE:
      return {
        ...state,
        isTableEditable: payload,
      };

    case VideoLibraryDataTableActionTypes.LOADING_ON_TABLE_DATA_ADD_EDIT:
      return {
        ...state,
        loading: payload,
      };

    case VideoLibraryDataTableActionTypes.SET_SEASON_INFO_OF_TABLE:
      return {
        ...state,
        tableSeasonInfo: payload,
      };

    case VideoLibraryDataTableActionTypes.RESET_TABLE:
      return initialState;

    default:
      return state;
  }
};
